import { useCallback } from "react";

import useClient from "hooks/useClient";

const useAcceptServiceEstimate = (): {
  acceptEstimate: (optionId: string, serviceId: string, estimateId: string, userRequest: string) => Promise<number>;
} => {
  const { client } = useClient();

  const acceptEstimate = useCallback(
    async (optionId: string, serviceId: string, estimateId: string, remarks) => {
      const { status } = await client({
        method: "put",
        url: `/option/${optionId}/request-service/${serviceId}/estimate/${estimateId}/accept-estimate`,
        data: { remarks },
      });
      return status;
    },
    [client]
  );

  return { acceptEstimate };
};

export default useAcceptServiceEstimate;
